<template>
  <div class="config-container">
    <el-collapse :value="categoryNames">
      <el-collapse-item :name="categoryName" :title="categoryName" v-for="({categoryName, groups, groupNames, activeGroup}, index) in categories" :key="categoryName" class="padding_0">
        <template v-if="groups.length > 1">
          <cx-slider :options="getSliderOptions(groupNames)" label="状态" :value.sync="categories[index].activeGroup" style="padding: 8px 12px;"></cx-slider>
          <el-collapse v-for="item in groups" v-if="item.groupName === activeGroup" :key="item.groupName" :value="getConfigNames(item.configs)" class="sub-menu-setting padding_0">
            <el-collapse-item :name="desc" :title="desc" v-for="{ name, type, desc, defaultValue, extraConfig } in item.configs" :key="desc">
              <component :is="type" :options="options"  :default-value="defaultValue" :config.sync="configData[name]" :extraConfig="extraConfig" />
            </el-collapse-item>
          </el-collapse>
      </template>
      <template v-else>
        <el-collapse :value="getConfigNames(groups[0].configs)" class="sub-menu-setting padding_0">
          <el-collapse-item :name="desc" :title="desc" v-for="{ name, type, desc, defaultValue, extraConfig } in groups[0].configs" :key="desc">
            <component :is="type" :options="options" :default-value="defaultValue" :config.sync="configData[name]" :extraConfig="extraConfig" />
          </el-collapse-item>
        </el-collapse>
      </template>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import propMapMixin from './propMapMixin.js'
export default {
  mixins: [propMapMixin],
  props: {
    options:Object,
    configs: Array,
    configData: undefined
  },
  computed: {
    categoryNames() {
      return this.categories.map(item => item.categoryName)
    },
    groupNames() {
      return [...new Set(this.configs.map(item => item.group))]
    },
    groups(categoryName) {
      return function (categoryName) {
        const groups = [...new Set(this.configs.filter(item => item.categoryName === categoryName).map(item => item.group))].map((item, index) => ({
          title: item,
          value: "" + item
        }))
        this.currentGroup = groups[0]?.value
        return groups
      }
    },
    groupConfigs() {
      return this.configs.reduce((groupConfigs, currentConfig) => {
        const { group } = currentConfig
        const currentGroupConfig = groupConfigs.find(item => item.groupName === group)
        if (!currentGroupConfig) {
          groupConfigs.push({
            groupName: group,
            configs: [currentConfig]
          })
        } else {
          currentGroupConfig.configs.push(currentConfig)
        }
        return groupConfigs
      }, []) 
    }
  },
  watch: {
    configs() {
      this.getCategories()
    }
  },
  data() {
    return {
      currentGroup: '',
      categories: []
    }
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    getConfigNames(configs) {
      return configs.map(item => item.desc)
    },
    getSliderOptions(names) {
      return names.map(item => ({title: item, value: item}))
    },
    getCategories() {
      const categories = []
      this.configs.forEach((item, index) => {
        const { categoryName, group } = item
        const currentCategory = categories.find(i => i.categoryName === (categoryName || '更多'))
        if (currentCategory) {
          const currentCategoryGroups = currentCategory.groups
          if (currentCategoryGroups) {
            const currentGroup = currentCategoryGroups.find(i => i.groupName === group)
            if (currentGroup) {
              currentGroup.configs.push(item)
            } else {
              currentCategory.groupNames.push(group)
              currentCategoryGroups.push({
                groupName: group,
                configs: [item]
              })
            }
          }
        } else {
          categories.push({
            categoryName: categoryName || '更多',
            groupNames: [group],
            activeGroup: group,
            groups: [{
              groupName: group,
              configs: [
                item
              ]
            }]
          })
        }
      })
      this.categories = categories
    }
  }
}
</script>
<style lang="scss">
.config-item-title {
  font-weight: 600;
  margin-bottom: 8px;
}
</style>
